import { olympusService as e } from "../../services/olympus/olympus.service.js";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
//#region src/lib/stores/comment-component-store/useCommentComponentStore.ts
var r = "__comments\nentity__", i = (e) => e.components.some((e) => e.type === "Avatar"), a = /* @__PURE__ */ new Set([
	"visible",
	"position",
	"viewpointPosition",
	"viewpointRotation"
]), o = (e, t) => `${e}:${t}`, s = (e) => {
	e.forEach((e) => {
		e.events.on("update", ({ dirtyProperties: t }) => {
			if (t.some((e) => !a.has(e))) {
				let t = g.getState().components;
				t.findIndex((t) => t.parentId === e.parentId && t.id === e.id) >= 0 ? g.getState().setComponents([...t]) : (console.warn(`CommentComponentStore: update for component ${e.parentId}:${e.id} not found`), g.getState().setComponents([...t, e]));
			}
		});
	});
}, c = (e) => {
	let t = e.getUniqueId();
	g.getState().components.find((e) => e.getUniqueId() === t) ? console.warn(`CommentComponentStore: attempted to add a known conversation component ${t}`) : (s([e]), g.getState().setComponents([...g.getState().components, e]));
}, l = (e) => {
	let t = g.getState().components.findIndex((t) => t.getUniqueId() === e);
	if (t >= 0) {
		let e = g.getState().components;
		e.splice(t, 1), g.getState().setComponents([...e]);
	}
}, u = (e) => {
	if (g.getState().entities.some((t) => t.id === e.id)) return;
	let t = [...g.getState().entities, e];
	if (g.getState().setEntities(t), !i(e)) {
		let t = e.components.filter((e) => e.type === "Conversation");
		if (s(t), t.length > 0) {
			let e = [...g.getState().components, ...t];
			g.getState().setComponents(e);
		}
		e.events.on("addComponent", ({ component: e }) => {
			e.type === "Conversation" && c(e);
		}), e.events.on("deleteComponent", ({ id: t }) => {
			l(o(e.id, t));
		});
	}
}, d = (e) => {
	u(e.entity);
}, f = (e) => {
	let t = g.getState().components.filter((t) => t.parentId !== e.entity.id);
	g.getState().setComponents(t), e.entity.components.forEach((t) => l(o(e.entity.id, t.id))), g.getState().setEntities(g.getState().entities.filter((t) => t.id !== e.entity.id));
}, p = !1, m = void 0, h = () => {
	e.client.spaceEntities.getAllEntities().forEach(u), g.setState({ spaceEntityLoadComplete: !0 });
}, g = n((e, t) => ({
	components: [],
	setComponents: (t) => {
		e({ components: t });
	},
	entities: [],
	setEntities: (t) => {
		e({ entities: t.filter((e) => !i(e)) });
	},
	get: (e, n) => {
		let r = t().entities.find((t) => t.id === e);
		if (!r) return;
		let i = r.components.find((e) => e.id === n);
		if (!(!i || i.type !== "Conversation")) return i;
	},
	initialise: (e) => {
		e ? p ? console.warn("CommentComponentStore: multiple initialisations of the store") : (e.internalEvents.on("space-entity-load-complete", h), e.internalEvents.on("v2-entity-added", d), e.internalEvents.on("v2-entity-deleted", f), p = !0, m = e) : console.warn("CommentComponentStore: initialisation of the store attempted without a valid Olympus client");
	},
	uninitialise: (t) => {
		p &&= (m !== t && console.warn("CommentComponentStore: wrong Olympus client passed to uninitialise, correct instance used"), m &&= (m.internalEvents.off("space-entity-load-complete", h), m.internalEvents.off("v2-entity-added", d), m.internalEvents.off("v2-entity-deleted", f), e({
			entities: [],
			components: [],
			spaceEntityLoadComplete: !1
		}), void 0), !1);
	},
	spaceEntityLoadComplete: !1
})), _ = (e) => t(g, e);
//#endregion
export { r as ROOT_COMMENT_ENTITY_NAME, g as commentComponentStore, _ as useCommentComponentStore };
